import { render, staticRenderFns } from "./recipientEditor.vue?vue&type=template&id=b22e69c8&scoped=true&"
import script from "./recipientEditor.vue?vue&type=script&lang=js&"
export * from "./recipientEditor.vue?vue&type=script&lang=js&"
import style0 from "./recipientEditor.vue?vue&type=style&index=0&id=b22e69c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22e69c8",
  null
  
)

export default component.exports